<div class="footer-with-buttons" [caLocalizationScope]="localizationScope">
  <button
    *ngIf="!showFormatConversionOptions"
    [title]="disableSaving ? ('createReportDisabled' | caLocalize) : ''"
    class="btn btn-primary me-2"
    data-automation-id="submit-button"
    title="{{ createReportTitle | caLocalize }}"
    [disabled]="disableSaving"
    (click)="onCreateReport()"
  >
    {{ createReportTitle | caLocalize }}
  </button>
  <f-split-dropdown
    *ngIf="showFormatConversionOptions"
    data-automation-id="submit-button"
    class="me-2"
    [btnStyle]="'btn-primary'"
    [text]="createReportTitle | caLocalize"
    [icon]="'f-i-pdf'"
    [disabled]="disableSaving"
    [placement]="dropdownPlacement"
    (buttonClick)="onCreateReport(OutputFormat.Pdf)"
  >
    <f-list>
      <f-list-item fDropdownItem (click)="onCreateReport(OutputFormat.Xlsx)">
        <div class="d-flex align-items-center gap-2 body-70">
          <i class="f-i f-i-md f-i-excel text-muted"></i>{{ 'exportAsExcel' | caLocalize }}
        </div>
      </f-list-item>
      <f-list-item fDropdownItem (click)="onCreateReport(OutputFormat.Docx)">
        <div class="d-flex align-items-center gap-2 body-70">
          <i class="f-i f-i-md f-i-word text-muted"></i>{{ 'exportAsWord' | caLocalize }}
        </div>
      </f-list-item>
      <f-list-item fDropdownItem (click)="onCreateReport(OutputFormat.Pptx)">
        <div class="d-flex align-items-center gap-2 body-70">
          <i class="f-i f-i-md f-i-powerpoint text-muted"></i>{{ 'exportAsPowerPoint' | caLocalize }}
        </div>
      </f-list-item>
    </f-list>
  </f-split-dropdown>
  @if (isConfigurable) {
  <a
    data-automation-id="customize"
    class="btn btn-primary ms-1"
    target="_blank"
    [href]="getExportReportLink()"
    (click)="onPreviewAndCustomizeClick()"
  >
    {{ 'customize' | caLocalize }}
  </a>
  }
  <button
    class="btn btn-secondary"
    [ngClass]="{ 'ms-0': isConfigurable }"
    data-automation-id="cancel-button"
    title="{{ 'cancel' | caLocalize }}"
    (click)="cancel()"
  >
    {{ 'cancel' | caLocalize }}
  </button>
</div>
